"use client";
import { pathTranslator } from "../../../utils/language";
import { List } from "../../Listbox/Listbox";
import styles from "./LanguageToggle.module.scss";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { Post } from "@aleksundshantu/aunds-hofreiter2026-types/client";

export const LanguageToggle = ({
  post,
  addWrapper = false,
}: {
  post: Post;
  hide?: boolean;
  addWrapper?: boolean;
}) => {
  const { locale } = useGlobalContext();
  const availableTranslations = pathTranslator(post);
  const showLanguageToggle = availableTranslations.length > 0;
  const onLanguagePick = (e: string) => {
    if (availableTranslations.length > 0) {
      document.cookie = `NEXT_LOCALE=${e}; path=/`;
      document.documentElement.lang = e;
      //setToggle(e);
    }
  };

  const ListJSX = (
    <List
      selected={locale}
      availableTranslations={availableTranslations}
      setSelected={onLanguagePick}
      items={
        process.env.NEXT_PUBLIC_LOCALES?.split(",")
          .filter(
            (l) =>
              l === locale || availableTranslations.some((a) => a.lang === l),
          )
          .map((l) => ({ label: l, value: l })) ?? []
      }
      disableDropdown={availableTranslations.length < 1 ? true : false}
      alwaysOpenUntil="navbar-breakpoint"
      closeOnSelection
    />
  );

  return (
    <>
      {showLanguageToggle &&
        (addWrapper ? (
          <div className={`language-wrapper ${styles["language-wrapper"]}`}>
            {ListJSX}
          </div>
        ) : (
          ListJSX
        ))}
    </>
  );
};
